import PropTypes from 'prop-types'
import React from 'react'

class InfiniteScroll extends React.Component {

  el = null

  static isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight
  }

  componentDidMount() {
    document.addEventListener('scroll', this.trackScrolling)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', () => {})
  }

  componentWillReceiveProps() {
    setTimeout(this.trackScrolling, 150)
  }

  trackScrolling = () => {
    if (this.el === null) return

    const wrappedElement = this.el
    if (InfiniteScroll.isBottom(wrappedElement) && this.props.shouldTrigger) {
      this.props.trigger()
    }
  }

  render() {
    const {children, shouldTrigger, trigger, ...other} = this.props
    return (
      <div {...other} ref={input => { this.el = input }}>
        {children}
      </div>
    )
  }

  static propTypes = {
    shouldTrigger: PropTypes.bool.isRequired,
    trigger: PropTypes.func.isRequired,
  }
}

export default InfiniteScroll



// WEBPACK FOOTER //
// ./src/common/components/InfiniteScroll.js